export default {
    windowClicked: ({commit, dispatch}) => {
        dispatch("setDatepickerOpen", "")
        commit("setParticipantsDropdownOpen", false)
        commit("setPackagesMobileDropdownOpen", false)
        commit("setSelectDropdownOpen_prestId", {id:'', current_select_location:''})
    },
}